import { NgModule } from '@angular/core';
import { SanfexComponent } from './sanfex.component';

@NgModule({
  declarations: [SanfexComponent],
  imports: [
  ],
  exports: [SanfexComponent]
})
export class SanfexModule { }
